export default __webpack_public_path__ + "media/images/features/local_delivery/episode5/admin-2a683d502042b919526ec80b214e8fd5.jpeg";